import React from 'react';
import { Link } from '@reach/router';

const Footer = () => {
  return (
    <div className='py-6 px-4 sm:px-6 lg:px-8'>
      <div className='flex flex-col sm:flex-row items-center justify-center sm:justify-start space-y-2 sm:space-y-0 sm:space-x-10'>
        <p className='text-sm sm:text-base leading-6 font-medium text-gray-500 mb-2 sm:mb-0 sm:mr-auto'>
          © 2020 Praiser. All Rights Reserved.
        </p>
        <Link
          to='/privacy-policy'
          className='text-sm sm:text-base leading-6 font-medium text-gray-600 hover:text-gray-900 focus:outline-none focus:text-gray-900 transition ease-in-out duration-150'
        >
          Privacy Policy
        </Link>
        <Link
          to='/terms-of-service'
          className='text-sm sm:text-base leading-6 font-medium text-gray-600 hover:text-gray-900 focus:outline-none focus:text-gray-900 transition ease-in-out duration-150'
        >
          Terms of Service
        </Link>
      </div>
    </div>
  );
};

export default Footer;
